export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS = 'applicantProfileDocuments'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_EMPTY =
  'applicantProfileDocumentsEmpty'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_RETRY =
  'applicantProfileDocumentsRetry'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING =
  'applicantProfileDocumentsOutstanding'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_ITEM =
  'applicantProfileDocumentsOutstandingItem'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_MORE =
  'applicantProfileDocumentsOutstandingMore'

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_TABLE =
  'applicantDocumentsTable'

export const APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_LIMIT = 6

export const APPLICANT_PROFILE_DOCUMENTS_OUTSTANDING_TEXT_COLOR =
  'var(--secondary-text-color)'

export const APPLICANT_PROFILE_DOCUMENTS_SKELETON_ROWS = 3

export const APPLICANT_DOCUMENTS_PAGE_SIZE = 20

export const ApplicantDocumentColumnName = {
  Name: 'name',
  Size: 'size_bytes',
  Uploaded: 'uploaded_at',
  UploadedBy: 'uploaded_by',
}

export const APPLICANT_DOCUMENT_COLUMNS_CONFIG = {
  [ApplicantDocumentColumnName.Name]: {
    index: 0,
    name: ApplicantDocumentColumnName.Name,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsNameColumnKey',
    visible: true,
  },
  [ApplicantDocumentColumnName.Size]: {
    index: 1,
    name: ApplicantDocumentColumnName.Size,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsSizeColumnKey',
    visible: true,
    width: 110,
  },
  [ApplicantDocumentColumnName.Uploaded]: {
    index: 2,
    name: ApplicantDocumentColumnName.Uploaded,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedColumnKey',
    visible: true,
    width: 180,
  },
  [ApplicantDocumentColumnName.UploadedBy]: {
    index: 3,
    name: ApplicantDocumentColumnName.UploadedBy,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedByColumnKey',
    visible: true,
    width: 240,
  },
}

export const QA_NAME_APPLICANT_PROFILE_DOCUMENTS_FOLDER =
  'applicantDocumentsFolder'

export const APPLICANT_PROFILE_DOCUMENTS_BREADCRUMB_APPLICANT = 'applicant'
